import charterSchoolIcon from '../assets/icons/school.png';
import fireDepartmentIcon from '../assets/icons/firedepartment.png';
import housingAuthorityIcon from '../assets/icons/housingauthority.png';
import municipalIcon from '../assets/icons/municipal.png';
import nonprofitIcon from '../assets/icons/nonprofit.png';
import policeDepartmentIcon from '../assets/icons/policedepartment.png';
import privateSchoolIcon from '../assets/icons/school.png';
import publicSchoolIcon from '../assets/icons/school.png';
import regionalIcon from '../assets/icons/regional.png';
import stateAgencyIcon from '../assets/icons/stateagency_ma.png';
import universityIcon from '../assets/icons/university.png';
import utilityIcon from '../assets/icons/utility.png';

export interface ProcuringTypeMeta {
  key: string;
  label: string;
  icon: string;
  tooltip?: string;
}

const PROCURING_TYPE_MAP: Record<string, ProcuringTypeMeta> = {
  'charter school': {
    key: 'charter-school',
    label: 'Charter School',
    icon: charterSchoolIcon,
    tooltip: 'Charter school or charter network',
  },
  'fire department': {
    key: 'fire-department',
    label: 'Fire Department',
    icon: fireDepartmentIcon,
    tooltip: 'Fire department or fire district',
  },
  'housing authority': {
    key: 'housing-authority',
    label: 'Housing Authority',
    icon: housingAuthorityIcon,
    tooltip: 'Public housing authority',
  },
  municipality: {
    key: 'municipality',
    label: 'Municipality',
    icon: municipalIcon,
    tooltip: 'City or town procurement office',
  },
  nonprofit: {
    key: 'nonprofit',
    label: 'Nonprofit',
    icon: nonprofitIcon,
    tooltip: 'Nonprofit or community organization',
  },
  'police department': {
    key: 'police-department',
    label: 'Police Department',
    icon: policeDepartmentIcon,
    tooltip: 'Police department or public safety office',
  },
  'private school': {
    key: 'private-school',
    label: 'Private School',
    icon: privateSchoolIcon,
    tooltip: 'Private or independent school',
  },
  'public school': {
    key: 'public-school',
    label: 'Public School',
    icon: publicSchoolIcon,
    tooltip: 'Public school or school district',
  },
  regional: {
    key: 'regional',
    label: 'Regional',
    icon: regionalIcon,
    tooltip: 'Regional authority or collaborative',
  },
  'state agency': {
    key: 'state-agency',
    label: 'State Agency',
    icon: stateAgencyIcon,
    tooltip: 'State-level agency or office',
  },
  university: {
    key: 'university',
    label: 'University',
    icon: universityIcon,
    tooltip: 'University or college',
  },
  utility: {
    key: 'utility',
    label: 'Utility',
    icon: utilityIcon,
    tooltip: 'Utility or water/sewer district',
  },
};

export const getProcuringTypeMeta = (type?: string | null): ProcuringTypeMeta | null => {
  if (!type) return null;
  const normalized = type.trim().toLowerCase();
  return PROCURING_TYPE_MAP[normalized] ?? null;
};
